import {NgModule} from '@angular/core';
import {ConfirmationService, ConfirmDialogModule, GrowlModule, ProgressSpinnerModule} from 'primeng/primeng';
import {MessageService} from 'primeng/components/common/messageservice';

@NgModule({
  imports: [
    GrowlModule
  ],
  exports: [
    GrowlModule,
    ConfirmDialogModule,
    ProgressSpinnerModule
  ],
  providers: [MessageService, ConfirmationService]
})
export class PrimengRootComponentsModule {
}



// WEBPACK FOOTER //
// A:/CM/links-ui/cm-ui-app-links/src/app/primeng-root-components/primeng-root-components.module.ts